export const TYPE_GENDER_MALE = 0
export const TYPE_GENDER_FEMALE = 1